import * as R from 'ramda'
import { SeenPatch } from '@weblite/ts-action/room'
import {
  DBFind,
  DBFindOne,
  DBInsert,
  DBRemove,
  DBRemoveMany,
  DBUpdateOne,
} from '@weblite/persist'

// TODO is mutex needed here?
const SEEN_COLLECTION = 'seenSync'

interface SeenPatchSync {
  roomId: string
  type: SeenPatch['type']
  seen: SeenPatch['seen']
  events: Record<number, number>
  ignoreUpdateRoomSeen: SeenPatch['ignoreUpdateRoomSeen']
}

export async function set(
  roomId: string,
  seen: number,
  roomType: SeenPatch['type'],
  ignoreUpdateRoomSeen: boolean,
) {
  const { nextKey } = (await DBFindOne(SEEN_COLLECTION, roomId)) || {}
  if (nextKey) {
    await DBUpdateOne(SEEN_COLLECTION, roomId, {
      $inc: { nextKey: 1 },
      $set: {
        seen,
        [`events.${nextKey}`]: 0,
        ignoreUpdateRoomSeen,
      },
    })
  } else {
    await DBInsert(SEEN_COLLECTION, {
      nextKey: 2,
      seen,
      roomId,
      type: roomType,
      ignoreUpdateRoomSeen,
      events: { '1': 0 },
    })
  }
}

export async function getAll() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const seenPatches: SeenPatchSync[] = await DBFind(SEEN_COLLECTION)

  async function unsetSeenPatch() {
    await Promise.all(
      seenPatches.map(seenPatch =>
        DBUpdateOne(SEEN_COLLECTION, seenPatch.roomId, {
          $unset: R.fromPairs(
            R.keys(seenPatch.events).map(key => [`events.${key}`, 1]),
          ),
        }),
      ),
    )
  }

  const pruneList: string[] = []

  const items = seenPatches
    .map(seenPatch => {
      if (R.isEmpty(seenPatch.events)) {
        pruneList.push(seenPatch.roomId)
        return null
      }
      return seenPatch
    })
    .filter(Boolean)

  if (pruneList.length) await DBRemoveMany(SEEN_COLLECTION, pruneList)

  return { items, del: unsetSeenPatch }
}

/** Remove connected fields */
export async function del(roomId: string): Promise<void> {
  await DBRemove(SEEN_COLLECTION, roomId)
}
